


/** Special Character Decode Map */
const decodedMap: Record<string, string> = {
    '&quot;': '"',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>'
};

export function parseSpecialCharacter(input: string) {
    const pattern = new RegExp(Object.keys(decodedMap).join('|'), 'g');
    const decoded = input.replace(pattern, match => decodedMap[match]);
    return decoded
}